import React from "react";
import { useTranslation } from "react-i18next";

import Switch from "features/components/Switch";
import Tooltip from "features/components/Tooltip";
import Typography from "features/components/Typography";

interface Props {
  smartGroups?: boolean;
  onSmartGroupsChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  displayName?: string;
  groupingLabel?: string;
}

const SmartGroupsSwitch = ({
  smartGroups,
  onSmartGroupsChange,
  displayName,
  groupingLabel,
}: Props) => {
  const { t } = useTranslation();

  if (smartGroups === undefined || !onSmartGroupsChange || !displayName) {
    return null;
  }

  const tooltip = groupingLabel
    ? t("pages:dashboard.attribute_grouping_tooltip", {
        dashboardName: displayName,
        groupingLabel,
      })
    : t("pages:dashboard.smart_grouping_tooltip", {
        dashboardName: displayName,
      });

  const label = groupingLabel
    ? t(
        smartGroups
          ? "pages:dashboard.grouping_on"
          : "pages:dashboard.grouping_off",
        { groupingLabel }
      )
    : t(
        smartGroups
          ? "pages:dashboard.smart_grouping_on"
          : "pages:dashboard.smart_grouping_off"
      );

  return (
    <div
      className="flex items-center"
      data-testid="smart-group-table-toggle-button"
      data-smart-group-state={smartGroups ? "on" : "off"}
      data-display-name={displayName}
    >
      <Switch
        checked={smartGroups}
        onChange={onSmartGroupsChange}
        size="small"
      />
      <div className="ml-2">
        <Tooltip title={tooltip} arrow>
          <Typography variant="button" className="uppercase">
            {label}
          </Typography>
        </Tooltip>
      </div>
    </div>
  );
};

export default SmartGroupsSwitch;
